import script from "./WorkWhiteHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkWhiteHouse.vue?vue&type=script&setup=true&lang=js"

import "./WorkWhiteHouse.vue?vue&type=style&index=0&id=48132f0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48132f0f"]])

export default __exports__